export const FLOW_CARD_VARIANT = {
    // A step in the flow: identity, type, meta controls, and a body of configured items.
    STEP: 'step',
    // An end state: identity and a label, no type column.
    OUTCOME: 'outcome',
};

export const FLOW_CARD_VARIANTS = Object.values(FLOW_CARD_VARIANT);

// Width of the identity column, so every card's type column starts on the same line.
export const FLOW_CARD_IDENTITY_WIDTH = 220;

export const FLOW_CARD_CONNECTOR_ICON = 'arrow-narrow-down';
